// Copied from Acend
import {
  FormLabel as ChakraFormLabel,
  FormLabelProps as ChakraFormLabelProps,
} from "@chakra-ui/react";
import React from "react";

interface FormLabelProps extends ChakraFormLabelProps {
  isInvalid?: boolean;
  isRequired?: boolean;
  fontWeight?: string;
}

export const FormLabel = ({
  isInvalid,
  isRequired,
  fontWeight = "regular",
  ...restProps
}: FormLabelProps) => (
  <ChakraFormLabel
    // This forces all FormLabels with isRequired to have semi-bold fontweight
    fontWeight={isRequired ? "semibold" : fontWeight}
    color={isInvalid ? "red.500" : "black"}
    {...restProps}
  />
);
